'use client';

import {
  ServicePageNavigationFragment,
  ServicePageStoreFragment,
} from '@business/gql/graphql';
import { Maybe } from 'graphql/jsutils/Maybe';
import { ReactNode } from 'react';
import SideMenuNavigation from './SideMenuNavigation';
import { StoreInfo } from './StoreInfo';
import config from '@utils/config';

export const DesktopMenu = ({
  slug,
  storeData,
  navigations,
  children,
}: {
  slug: string;
  storeData?: Maybe<ServicePageStoreFragment>;
  navigations?: Maybe<ServicePageNavigationFragment>[];
  children?: ReactNode;
}) => {
  const { locale } = config;

  return (
    <nav className="hidden flex-col divide-y border-r font-sans lg:col-span-3 lg:flex xl:col-span-2">
      <div className="flex flex-col px-4  md:py-6 [&>div:last-child]:md:pt-5 ">
        {navigations
          ? navigations?.map((navigation) => (
              <SideMenuNavigation
                key={navigation?.sys?.id}
                slug={slug}
                navigation={navigation}
                locale={locale}
              />
            ))
          : null}
        {children}
      </div>
      {storeData ? (
        <StoreInfo storeData={storeData} className="px-4 pb-4 pt-6" />
      ) : null}
    </nav>
  );
};
